import React, { useMemo } from 'react';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
import { FormikTextField } from '../../../common/formik-material-ui/FormikTextField';
import { FormControlLabel } from '@mui/material';
import { FormikSwitch } from '../../../common/formik-material-ui/FormikSwitch';

import { useSnackbarWithStyles } from '../notifications/SnackbarProviderWithStyles';
import { useUpdateAuditMetaDataMutation } from '../../../api/apigQuery';
import { IUserAtom } from 'src/recoil/atoms/user';
import { GridRowData } from '@mui/x-data-grid';

const EditAuditMetaDataModal = ({
  show,
  handleClose,
  setRefetchToggleForAuditMetaData,
  row,
  userAtomContents,
}: {
  show: boolean;
  handleClose: () => void;
  setRefetchToggleForAuditMetaData: (props: any) => void;
  row: GridRowData;
  userAtomContents: IUserAtom;
}) => {
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const [updateAuditMetaData] = useUpdateAuditMetaDataMutation();

  const intialValues = useMemo(() => {
    return {
      fieldLabel: row?.fieldLabel ?? '',
      isAuditable: row?.isAuditable === 1,
      internalViewOnly: row?.internalViewOnly === 1,
    };
  }, [row]);
  return (
    <Formik
      onSubmit={async (values, _actions) => {
        try {
          const response = await updateAuditMetaData({
            userSettings: {
              apikey: userAtomContents?.apikey,
              businessId: userAtomContents?.businessid,
              userId: userAtomContents?.userid,
              businessid: userAtomContents?.businessid,
              userid: userAtomContents?.userid,
            },
            updatedByUserId: userAtomContents?.userid,
            updateRows: [
              {
                auditMetaDataId: row.id,
                fieldLabel: values.fieldLabel,
                isAuditable: values.isAuditable ? 1 : 0,
                internalViewOnly: values.internalViewOnly ? 1 : 0,
              },
            ],
          });
          if ('data' in response && response.data.length > 0) {
            enqueueSnackbarWithStyles({
              message: `Successfully Edited Audit Meta Data - ${row.id}`,
              alertProps: { severity: 'success' },
            });
          }
        } catch (error) {
          enqueueSnackbarWithStyles({
            message: `Encountered an error trying to edit the ${row.id} Audit Meta Data`,
            alertProps: { severity: 'warning' },
          });
        }

        setRefetchToggleForAuditMetaData({});
        handleClose();
      }}
      initialValues={intialValues}
    >
      {(formik) => {
        return (
          <ModalWithStyles
            onSubmit={formik.handleSubmit}
            title={`Edit Audit Meta Data ${row?.columnName} Column`}
            aria-labelledby="example-modal-sizes-title-lg"
            show={show}
            onHide={() => {
              handleClose();
              formik.resetForm({});
            }}
            isSubmitting={formik.isSubmitting}
            isLoading={formik.isSubmitting}
            size="sm"
          >
            <div className="row">
              <div className="col-lg-6">
                <FormikTextField
                  id="standard-basic"
                  label="Field Label"
                  name="fieldLabel"
                  formik={formik}
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </div>
              <div className="col-lg-6">
                <FormControlLabel
                  control={
                    <FormikSwitch
                      name="isAuditable"
                      formik={formik}
                      color="primary"
                      type="checkbox"
                    />
                  }
                  label="Is Auditable &nbsp;&nbsp;"
                />
                <FormControlLabel
                  control={
                    <FormikSwitch
                      name="internalViewOnly"
                      formik={formik}
                      color="primary"
                      type="checkbox"
                    />
                  }
                  label="Internal View Only &nbsp;&nbsp;"
                />
              </div>
            </div>
          </ModalWithStyles>
        );
      }}
    </Formik>
  );
};
export default EditAuditMetaDataModal;
